export const userMixin = {
   data: function(){
      return {
         roles: {
            "Admin" : "admin",
            "User" : "user"
         },
         users: {}
      }
   },
   computed: {
      isLogged: function(){
         var that = this;
         setTimeout(()=>{
            if(that.$socket.disconnected){
               that.$store.dispatch('logOut');
            }
         }, 3000);
         if(this.$store.getters.isLogged){
            return true;
         }
         return false;
      },
      loggedUser: function(){
         return this.$store.getters.userData;
      },
      loggedRole(){
         return this.$store.getters.getRole;
      },
      isClient(){
         return (this.loggedRole === 'client' || this.loggedRole === 'user');
      },
      isAdmin(){
         return (this.loggedRole === 'god4all' || this.loggedRole === 'admin');
      }
   },
   methods: {
      getUsers: function(){
         this.$http.get('user').then(res => {
            this.users = res.data.obj;
         });
      },
      findInUsers: function(key, val){
         for (let i in this.users) {
            let user = this.users[i];
            if(user[key] == val) {
               return true;
            }
         }
         return false;
      },
      deleteUser: function(user){
         this.$socket.emit('userDelete', user);
      }
   },
   sockets: {
      doLogout(){
         this.$store.dispatch('logOut');
      },
      refreshTokenBitte(){
         // this.$socket.emit('refreshMyToken');
      },
      userTokenRefresh: function (user) {
      //    var that = this;
      //    var expTime = 1*24*60*60*1000; // 1 day (d*h*m*s*ms)
      //    setTimeout(()=>{
      //       if(!user || typeof(user) === 'undefined' || !user.token){
      //          that.$store.dispatch('logOut');
      //       } else {
      //          let userData = {
      //             "_id": user._id,
      //             "firstName": user.firstName,
      //             "lastName": user.lastName,
      //             "email": user.email,
      //             "role": user.role,
      //             "language": user.language,
      //             "token": user.token,
      //             "authTokenExpiration": Date.now() + expTime
      //          };
      //          that.$store.dispatch('logIn', userData);
      //       }
      //    }, 2000);
      }
   }
};


// WEBPACK FOOTER //
// ./src/Banet/mixins/userMixin.js